import { fetchDataAndProceed } from "../../config/utils"
import { METHOD_TYPES } from "../../config/constants"

export const getAllFractureData = (data, callback) => {
  return fetchDataAndProceed("/admin/v1/fractureAnalysis", METHOD_TYPES.GET, data, callback)
}

export const updateFractureData = (data, callback) => {
  return fetchDataAndProceed("/admin/v1/fractureAnalysis/graph", METHOD_TYPES.GET, data, callback)
}



// WEBPACK FOOTER //
// ./src/data/redux/fracture_details/api.js